import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import axios from "axios";
import swal from "sweetalert";
import { handleErrorFetchingData } from "../../../../functions/errorHandling";

export default function DeleteFunctionalGroupModal({ functionalGroup, getFunctionalGroups }) {
  const [show, toggleShow] = useState(false);

  const handleSoftDelete = () => {
    swal({
      text: `Deleting ${functionalGroup.name}... Please stand by.`,
      icon: require("../../../../static/images/spinner.gif"),
      button: false,
    });
    axios
      .patch(functionalGroup.url, { is_active: false }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(() => {
        swal({
          title: "Deleted",
          text: `${functionalGroup.name} has been successfully deleted.`,
          icon: "success",
          button: "OK",
        }).then(() => {
          getFunctionalGroups(); // Refresh the list of functional groups
          toggleShow(false); // Close the modal
        });
      })
      .catch((error) => {
        const message = `There was an error deleting the functional group: ${functionalGroup.name}`;
        handleErrorFetchingData(error, message);
      });
  };

  return (
    <React.Fragment>
      <Button variant="danger" onClick={() => toggleShow(true)}>
        Delete Functional Group
      </Button>

      <Modal show={show} onHide={() => toggleShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Functional Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the functional group: <strong>{functionalGroup.name}</strong>? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => toggleShow(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleSoftDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

DeleteFunctionalGroupModal.propTypes = {
  functionalGroup: PropTypes.object.isRequired,
  getFunctionalGroups: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/DeleteFunctionalGroupModal.js